import React from "react";
import { Link } from "react-router-dom";
import { COMMUNITY_REWARD } from "../../lib/communityReward";

/** Tiny loyalty strip in cart — full reward story lives on /community-reward. */
export default function CommunityRewardCartNote() {
  const r = COMMUNITY_REWARD;
  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border border-gold/25 bg-[#FCFAF4] px-3 py-2.5">
      <p className="text-xs text-forest m-0 leading-snug">{r.cartMessage}</p>
      <Link
        to="/community-reward"
        className="shrink-0 text-[11px] font-medium text-forest underline underline-offset-2 hover:text-gold"
      >
        Learn more
      </Link>
    </div>
  );
}
